import { SwipeableDrawerProps as MuiSwipleableDrawerProps } from '@mui/material/SwipeableDrawer'

export type SwipeableDrawerProps = MuiSwipleableDrawerProps
